
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pakiety/[slug]",
      function () {
        return require("private-next-pages/pakiety/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pakiety/[slug]"])
      });
    }
  